import { Modal, ModalDialog } from '@mui/joy';

import { useState } from 'react';

import { StructuredPromptSchema } from '@/Pages/Playground/components/manifest/serialized/prompts/ManifestStructuredPrompt';

import { SchemaEditorModalBody } from './SchemaEditorModalBody';
import { EditorModalHeader } from './components/EditorModalHeader';
import { SchemaEditorVariant } from './types';

export function SchemaEditorModal({
  isOpen,
  onClose,
  value,
  onSubmit,
  onRemove,
  title,
  readOnly = false,
}: {
  isOpen: boolean;
  onClose?: () => void;
  value: StructuredPromptSchema;
  onSubmit?: (value: StructuredPromptSchema) => void;
  onRemove?: () => void;
  title?: string;
  readOnly?: boolean;
}) {
  const [localValue, setLocalValue] = useState(value);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalDialog
        style={{
          maxWidth: '800px',
          width: '100%',
          maxHeight: '600px',
        }}
      >
        <EditorModalHeader
          title={title ?? 'Edit Output Schema'}
          description="The model will return a JSON object that matches the defined schema. Each specified property in the schema will be a key in the output."
          link="https://docs.langchain.com/langsmith/prompt-engineering-concepts#structured-output"
        />
        <SchemaEditorModalBody
          value={localValue}
          setValue={setLocalValue}
          onSubmit={onSubmit}
          onRemove={onRemove}
          variant={SchemaEditorVariant.SCHEMA}
          readOnly={readOnly}
          onClose={onClose}
        />
      </ModalDialog>
    </Modal>
  );
}
